import get from 'lodash/get';
import { LOCAL_STORAGE_AND_COOKIE_ITEM_KEYS, SOURCE_CLIENTS, SOURCE_CLIENT_HOST_NAMES_MATCHERS } from '../constants';
import type { TSourceClients } from '../types';
import { getItemFromPersistentStore } from './Persist';

const getSourceClient = (): TSourceClients => {
  const hostName = get(window, 'location.hostname', '');
  const clientInPersistentStore = getItemFromPersistentStore(
    LOCAL_STORAGE_AND_COOKIE_ITEM_KEYS.CLIENT,
    SOURCE_CLIENTS.MERCHANT
  );

  if (
    clientInPersistentStore === SOURCE_CLIENTS.DAN_CENTER ||
    hostName.includes(SOURCE_CLIENT_HOST_NAMES_MATCHERS.DAN_CENTER)
  ) {
    return SOURCE_CLIENTS.DAN_CENTER;
  } else if (hostName.includes(SOURCE_CLIENT_HOST_NAMES_MATCHERS.MESSAGE_CENTER)) {
    return SOURCE_CLIENTS.MESSAGE_CENTER;
  }
  return SOURCE_CLIENTS.MERCHANT;
};

export default getSourceClient;
